<template>
    <div class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i>数据分析</el-breadcrumb-item>
                <el-breadcrumb-item>事件管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='项目'>
                                <el-select size='mini' clearable v-model='queryParams.projectAppId' filterable
                                           placeholder='请选择'>
                                    <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                        :value="item.appId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='类型'>
                                <el-select size='mini' clearable v-model='queryParams.commonEvent' filterable
                                           placeholder='请选择事件类型'>
                                    <el-option v-for='item in trackEventTypeOption' :key='item.value'
                                               :label='item.label' :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label='事件ID' prop='userName'>
                                <el-input v-model='queryParams.eventId' placeholder='请输入事件ID' clearable size='mini'
                                          style='width: 180px' @keyup.enter.native='handleQuery' />
                            </el-form-item>

                            <el-form-item label='事件名' prop='userName'>
                                <el-input v-model='queryParams.eventName' placeholder='事件名' clearable size='mini'
                                          style='width: 180px' @keyup.enter.native='handleQuery' />
                            </el-form-item>
                            <el-form-item label='统计埋点数据'>
                                <el-switch v-model='queryParams.containTrackData' active-color='#13ce66'
                                    inactive-color='#ff4949'>
                                </el-switch>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4'>
                        <el-button type='primary' plain icon='el-icon-plus' size='mini' @click='handleAdd'>新增事件
                        </el-button>
                        
                        <el-button type='primary' plain icon='el-icon-plus' size='mini'
                                   @click='handleOpenImportEventDeclaration'>导入事件定义
                        </el-button>
                    </el-col>
                </el-row>
            </div>

            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='trackEventList'
                      @sort-change='handleSortChange'>
                <el-table-column width='150' sortable='custom' label='事件名' fixed align='center' prop='data.eventName' />
                <el-table-column width='150' label='事件ID' align='center' prop='data.eventId'
                                 :show-overflow-tooltip='true' />
                <el-table-column width='100'
                                 v-if='queryParams.containTrackData && queryParams.containTrackData === true'
                                 label='昨日事件数'
                                 align='center' prop='yesterdayCount'>
                    <template slot-scope='scope'>
                        <span style='color: #F56C6C'>{{ scope.row.yesterdayCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='100'
                                 v-if='queryParams.containTrackData && queryParams.containTrackData === true'
                                 label='今日事件数'
                                 align='center' prop='todayCount'>
                    <template slot-scope='scope'>
                        <span style='color: #409EFF'>{{ scope.row.todayCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='是否上报' align='center'>
                    <template slot-scope='scope'>
                        <el-switch size='mini' @change='handleUpdateTrackEvent(scope.row)'
                                   v-model='scope.row.data.status' />
                    </template>
                </el-table-column>
                <el-table-column width='200' label='是否通用' align='center'>
                    <template slot-scope='scope'>
                        <span style='color: #F56C6C' v-if='scope.row.data.commonEvent'>通用</span>
                        <span style='color: #409EFF' v-else>非通用</span>
                    </template>
                </el-table-column>
                <el-table-column label='参数个数' width='70' align='center' prop='parameter'>
                    <template slot-scope='scope'>
                        <span style='color: #409EFF'>{{ scope.row.parameter.length }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='事件数据数'
                                 v-if='queryParams.containTrackData && queryParams.containTrackData === true'
                                 width='100'
                                 align='center' prop='parameter'>
                    <template slot-scope='scope'>
                        <span style='color: #F56C6C'>{{ scope.row.totalTrackData }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='去重策略' width='100' align='roleName' prop='roleName'>
                    <template slot-scope='scope'>
                        <span>{{ computeDeduplicationStrategy(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='100' label='创建用户' align='center'>
                    <template slot-scope='scope'>
                        <span>{{ computeUserAccount(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column width='200' label='描述' align='center' prop='data.triggerDesc' />
                <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='data.createTime' />
                <el-table-column label='操作' align='center' width='200' fixed='right'
                                 class-name='small-padding fixed-width'>
                    <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                        <el-button size='mini' type='text' icon='el-icon-edit' @click='handleUpdate(scope.row)'>修改
                        </el-button>
                        
                        <el-button size='mini' type='text' icon='el-icon-s-marketing'
                                   @click='handleViewDetail(scope.row)'>详情
                        </el-button>
                        
                        <el-button icon='el-icon-delete' size='mini' type='text' @click='handleDelete(scope.row)'>删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div class='pagination'>
                <el-pagination :current-page='queryParams.pageNum' :page-sizes='[15, 30, 45, 60, 75, 100, 200, 300]'
                               :page-size='queryParams.pageSize' :total='queryParams.total' background
                               layout='sizes, prev, pager, next' @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>

            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :visible.sync='open' width='40%' append-to-body @close='cancel'>
                <template slot='title'>
                    <el-row>
                        <el-col :span='12'>
                            <span>{{ title }}</span>
                        </el-col>
                        <el-col :span='12'>
                            <el-link :href='`${envConfig.cdnUrl}/docFile/track_analyse.pdf`' target='_blank'
                                     type='primary'>事件埋点文档
                            </el-link>
                        </el-col>
                    </el-row>
                </template>
                <el-form style='margin-top: 1rem' label-width='150' :model='insertTrackEvent' :rules='trackEventRule'
                         ref='insertTrackEvent'>
                    <el-form-item label='事件ID' prop='eventId' key='eventId'>
                        <el-input :disabled='updateStatus' size='mini' type='text' v-model='insertTrackEvent.eventId'
                                  autocomplete='off' />
                    </el-form-item>
                    <el-form-item label='事件名' prop='eventName' key='eventName'>
                        <el-input size='mini' type='text' v-model='insertTrackEvent.eventName' autocomplete='off' />
                    </el-form-item>
                    <el-form-item label='' prop='eventName' key='eventName'>
                        <el-tooltip class='item' effect='dark'
                                    content='通用事件创建之后，可以被所有项目使用，在事件上报时，项目名(projectName)字段设置为对应项目即可。'
                                    placement='top'>
                            <icon-ify-icon style='cursor: pointer' icon='mdi:tooltip-question-outline' />
                        </el-tooltip>
                        通用事件 &nbsp;<el-switch v-model='insertTrackEvent.commonEvent' active-color='#13ce66'
                                                  inactive-color='#ff4949'>
                    </el-switch>
                    </el-form-item>
                    <el-form-item v-if='!insertTrackEvent.commonEvent' label='项目' prop='projectAppId'
                                  key='projectAppId'>
                        <el-select size='mini' v-model="insertTrackEvent.projectAppId" filterable placeholder="请选择">
                            <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                :value="item.appId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="触发时机描述" prop="triggerDesc" key='triggerDesc'>
                        <el-input :rows='2' size='mini' type='textarea' v-model='insertTrackEvent.triggerDesc'
                                  autocomplete='off' />
                    </el-form-item>
                    <el-form-item label="事件数据去重" prop="deduplication" key='deduplication'>
                        <el-switch size='mini' v-model='insertTrackEvent.deduplication' />
                    </el-form-item>
                    <el-form-item v-if='insertTrackEvent.deduplication' label='事件数据去重策略'
                                  prop='deduplicationStrategy'
                                  key='deduplicationStrategy'>
                        <el-select size='mini' v-model='insertTrackEvent.deduplicationStrategy' filterable
                                   placeholder='请选择'>
                            <el-option v-for='item in deduplicationStrategyOption' :key='item.value' :label='item.label'
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if='insertTrackEvent.deduplication' label='事件数据去重值'
                                  prop='deduplicationStrategyValue' key='deduplicationStrategyValue'>
                        <el-input size='mini' type='text' v-model='insertTrackEvent.deduplicationStrategyValue'
                                  autocomplete='off' />
                    </el-form-item>
                </el-form>

                <el-divider>事件参数</el-divider>
                <el-form style='margin-top: 1rem' label-width='150'>
                    <el-dialog width='30%' title='添加或修改事件参数' :visible.sync='openTrackParameter' append-to-body>
                        <el-form style='margin-top: 1rem' label-width='150' :model='insertTrackParameter'
                                 :rules='trackParameterRule' ref='insertTrackParameter'>
                            <el-form-item label="参数名" prop="name" key='name'>
                                <el-input size='mini' type='text' v-model='insertTrackParameter.name'
                                          autocomplete='off' />
                            </el-form-item>
                            <el-form-item label="参数类型" prop="type" key='type'>
                                <el-select size='mini' v-model="insertTrackParameter.type" filterable placeholder="请选择">
                                    <el-option v-for='item in trackParameterTypeOption' :key='item.value'
                                               :label='item.label' :value='item.value'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="参数描述" prop="description" key='description'>
                                <el-input :rows='2' size='mini' type='textarea'
                                          v-model='insertTrackParameter.description' autocomplete='off' />
                            </el-form-item>
                        </el-form>

                        <div slot='footer' class='dialog-footer'>
                            <el-button type='primary' @click='submitTrackParameter'>确 定</el-button>
                            <el-button @click='openTrackParameter = false'>取 消</el-button>
                        </div>
                    </el-dialog>
                    <el-table :cell-style="{ textAlign: 'center' }" :data='trackParameterList'>
                        <el-table-column width='150' label='参数名' fixed align='center' prop='name' />
                        <el-table-column width='150' label='参数类型' align='center' prop='type' />
                        <el-table-column width='200' label='参数描述' align='center' prop='description' />
                        <el-table-column label='操作' align='center' width='200' fixed='right'
                                         class-name='small-padding fixed-width'>
                            <template slot-scope='scope' slot='header'>
                                <template>
                                    <slot name='table-header'></slot>
                                </template>
                                <el-button type='text' @click='addEmptyDynamicForm' size='mini'>增加一项</el-button>
                                <el-button type='text' @click='openCopyTrackParameter = true' size='mini'>拷贝
                                </el-button>
                            </template>
                            <template slot-scope='scope' v-if='scope.row.userId !== 1'>
                                <el-button size='mini' type='text' icon='el-icon-edit'
                                           @click='handleUpdateTrackParameter(scope.row)'>修改
                                </el-button>
                                
                                <el-button icon='el-icon-delete' size='mini' type='text'
                                           @click='handleDeleterTrackParameter(scope.$index, scope.row)'>删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    
                    <el-dialog width='30%' title='拷贝项目事件参数' :visible.sync='openCopyTrackParameter'
                               append-to-body>
                        
                        <el-form style='margin-top: 1rem' label-width='150'>
                            <el-form-item label="选择项目" prop="type">
                                <el-select size='mini' @change='queryTrackEvent'
                                           v-model='copyTrackParameter.projectAppId' filterable placeholder='请选择'>
                                    <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                        :value="item.appId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="选择项目" prop="type">
                                <el-select size='mini' v-model='copyTrackParameter.eventId' filterable
                                           placeholder='请选择'>
                                    <el-option v-for='item in copyTrackParameter.queriedTrackEventList' :key='item.id'
                                               :label='`${item.eventId} ${item.eventName}`' :value='item.id'>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                        <div slot='footer' class='dialog-footer'>
                            <el-button type='primary' @click='handleCopyTrackParameter'>拷 贝</el-button>
                        </div>
                    </el-dialog>
                </el-form>

                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button type='primary' @click='submitForm'>{{ updateStatus ? '修 改' : '添 加' }}</el-button>
                        <el-button @click='cancel'>取 消</el-button>
                    </div>
                </div>
            </el-dialog>
            
            <el-dialog :visible.sync='batchImportEventDeclaration.open' title='批量导入事件定义' width='40%'
                       @close='handleImportCancel' append-to-body>
                <el-form style='margin-top: 1rem' label-width='150'>
                    
                    <el-form-item label='项目' prop='projectAppId' key='projectAppId'>
                        <el-select size='mini' v-model='batchImportEventDeclaration.params.projectAppId' filterable
                                   placeholder='请选择'>
                            <el-option v-for='item in projectInfoList' :key='item.appId' :label='item.cnName'
                                       :value='item.appId'>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label='事件已定义时跳过该事件'>
                        <el-switch v-model='batchImportEventDeclaration.params.skipWhenConflict' active-color='#13ce66'
                                   inactive-color='#ff4949'>
                        </el-switch>
                    </el-form-item>
                    <el-form-item label='JSON文件'>
                        <el-upload
                            ref='importUpload'
                            :limit='1'
                            :auto-upload='false'
                            action='#'
                            drag
                            :on-change='handleFileChange'
                        >
                            <div>
                                <i class='el-icon-upload'></i>
                                <div class='el-upload__text'>将文件拖到此处，或<em>点击上传</em></div>
                            </div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                
                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button type='primary' style='float: left'
                                   @click='batchImportEventDeclaration.openJsonFormat = true'>查看JSON格式
                        </el-button>
                        <el-button type='primary' @click='handleImport'>导入</el-button>
                        <el-button @click='handleImportCancel'>取 消</el-button>
                    </div>
                </div>
            </el-dialog>
            
            <el-dialog title='JSON格式' :visible.sync='batchImportEventDeclaration.openJsonFormat' width='40%'
                       append-to-body>
                <vue-json-pretty :data='batchImportEventDeclaration.jsonFormat' />
            </el-dialog>
        </div>
    </div>
</template>

<script>

import { message } from '@/utils/message';
import { queryProjectInfoList } from '@api/ProjectInfo';
import { trackEventApi } from '@api/Track/trackEvent';
import { pageUtil } from '@/utils/pageUtil';
import { selectEmployeeList } from '@api/dashboard';
import { trackParameterApi } from '@api/Track/trackParameter';
import CottonDynamicForm from '@/components/component/CottonDynamicForm.vue';
import TrackParameterDynamicForm from '@view/track/eventManage/TrackParameterDynamicForm.vue';
import IconIfyIcon from '@/components/component/icon/IconIfyIcon.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { envConfig } from '@root/env';

export default {
    name: 'User',
    components: { IconIfyIcon, TrackParameterDynamicForm, CottonDynamicForm, VueJsonPretty },
    data() {
        return {
            envConfig,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            // 部门树选项
            projectTreeOptions: [],
            // 是否显示弹出层
            open: false,
            defaultProps: {
                label: 'label'
            },
            queryProjectName: undefined,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],

                projectAppId: undefined,
                deduplicationStrategy: undefined,
                eventId: undefined,
                eventName: undefined,
                commonEvent: undefined,
                containTrackData: undefined
            },

            trackEventList: [],
            adminUserList: [],
            currentTrackEvent: {},
            currentEventTrackParameterList: [],

            deduplicationStrategyOption: [
                {
                    label: '固定天数',
                    value: 'TIME'
                },
                {
                    label: '无',
                    value: 'NONE'
                }
            ],
            trackParameterTypeOption: [
                {
                    label: '字符串',
                    value: 'STRING'
                },
                {
                    label: '数值',
                    value: 'INTEGER'
                }
            ],
            updateStatus: false,
            projectInfoList: [],
            firstStepStatus: 'wait',
            secondStepStatus: 'wait',
            thirdStepStatus: 'wait',
            insertEventAndParameterActiveTabName: '1',
            insertTrackEvent: {},
            insertTrackParameter: {},
            trackEventRule: {
                eventId: [
                    { message: '请输入事件ID(只能含有字母和_)', required: true, trigger: 'blur' }
                ],
                eventName: [
                    { message: '请输入事件名', required: true, trigger: 'blur' }
                ],
                projectAppId: [
                    { message: '请选择项目', required: true, trigger: 'blur' }
                ],
                deduplicationStrategyValue: [
                    {
                        trigger: 'blur', validator: (rule, value, callback) => {
                            if (this.insertTrackEvent.deduplication) {
                                if (!value || value === '') {
                                    callback(new Error('请输入数据去重值' +
                                        '' +
                                        '' +
                                        ''))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        }
                    }
                ]
            },
            trackParameterRule: {
                name: [
                    { message: '请输入参数名', required: true, trigger: 'blur' }
                ]
            },
            trackParameterList: [],
            currentTrackParameter: {},
            neededDeleteTrackParameterList: [],
            openTrackParameter: false,
            updateTrackParameterStatus: true,
            openCopyTrackParameter: false,
            copyTrackParameter: {
                projectAppId: undefined,
                eventId: undefined,
                queriedTrackEventList: []
            },
            trackEventTypeOption: [
                {
                    label: '通用事件',
                    value: true
                },
                {
                    label: '非通用事件',
                    value: false
                }
            ],
            batchImportEventDeclaration: {
                open: false,
                params: {
                    skipWhenConflict: true,
                    file: undefined,
                    projectAppId: undefined
                },
                openJsonFormat: false,
                jsonFormat: {
                    'datas': [
                        {
                            'event_name': '事件Id 全字母',
                            'title': '事件名',
                            'desc': '事件触发描述',
                            'event_status': false,
                            'params': [
                                {
                                    'param_name': '事件参数字段名',
                                    'type': 'string | int',
                                    'title': '事件参数描述'
                                }
                            ]
                        }
                    ]
                }
            }
        };
    },
    watch: {
        // 根据名称筛选项目组
        queryProjectName(val) {
            this.$refs.tree.filter(val);
        }
    },
    computed: {
        computeUserAccount() {
            return (data) => {
                for (let i = 0; i < this.adminUserList.length; i++) {
                    if (data.data.createUserId === this.adminUserList[i].userId) {
                        return this.adminUserList[i].account
                    }
                }
            }
        },
        computeDeduplicationStrategy() {
            return (data) => {
                for (let i = 0; i < this.deduplicationStrategyOption.length; i++) {
                    if (data.data.deduplicationStrategy === this.deduplicationStrategyOption[i].value) {
                        return this.deduplicationStrategyOption[i].label
                    }

                    if (i === this.deduplicationStrategyOption.length - 1) {
                        return '无'
                    }
                }
            }
        }
    },
    created() {
        this.getList();
        this.initData()
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size
            this.queryParams.pageNum = 1
            this.getList()
        },
        async handleSortChange({ column, prop, order }) {
            if (prop.indexOf("data.") === 0) {
                prop = prop.substring("data.".length, prop.length)
            }
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList)
            this.getList()
        },
        initData() {
            this.adminUserList = []
            selectEmployeeList({ pageSize: 10000 }).then(result => {
                this.adminUserList = result.data
            })
            // 获取所有的项目组
            queryProjectInfoList({ pageSize: 10000 }).then(result => {
                this.projectInfoList = result.data.result;
            })
        },
        getList() {
            this.trackEventList = []
            this.loading = true;
            // 获取所有的事件
            trackEventApi.queryTrackEventDetail(this.queryParams).then(result => {
                if (result.code === 200) {
                    if (result.data) {
                        this.trackEventList = result.data.result
                    }
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize
                }
                this.loading = false
            })
        },
        // 筛选节点
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1;
        },
        // 节点单击事件
        handleNodeClick(data) {
            this.queryParams.projectAppId = data.appId
            this.getList()
        },
        // 取消按钮
        cancel() {
            this.currentSetEventInfoStatus = true
            this.open = false;
            this.getList()
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 15,
                sortSqlList: [
                    'createTime desc'
                ],
            };
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.userId);
            this.updateStatus = true;
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.open = true;
            this.title = '分配分组';
            this.updateStatus = false;
            this.updateTrackParameterStatus = false
            this.insertTrackEvent = {}
            this.trackParameterList = []
            this.currentSetEventInfoStatus = true
        },
        handleOpenImportEventDeclaration() {
            this.batchImportEventDeclaration.open = true;
            this.batchImportEventDeclaration.params.file = undefined;
            this.batchImportEventDeclaration.params.skipWhenConflict = true;
            
            this.$nextTick(() => {
                this.$refs.importUpload.clearFiles();
            });
        },
        handleRemove() {
            this.open = true;
            this.title = '移除项目组';
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.currentTrackEvent = row;
            this.open = true;
            this.updateStatus = true;
            this.title = '修改事件信息';
            this.insertTrackEvent = row.data
            this.queryTrackParameter()
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除"' + row.data.eventName + '"的数据项？').then(function() {
                return trackEventApi.deleteTrackEvent(row.data);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    message.success('删除成功')
                }
            }).catch(() => {
            });
        },
        /** 提交按钮 */
        submitForm: function() {
            this.$refs.insertTrackEvent.validate((valid) => {
                if (valid) {
                    if (this.trackParameterList.length === 0) {
                        message.error('埋点事件参数不能为空!')
                        return true
                    }
                    if (this.updateStatus) {
                        // 修改操作
                        trackEventApi.updateTrackEvent(this.insertTrackEvent).then(result => {
                            if (result.code === 200) {
                                message.success('事件信息修改成功')
                                
                                // 删除事件参数
                                if (this.neededDeleteTrackParameterList.length > 0) {
                                    this.neededDeleteTrackParameterList.filter(t => t.id).forEach(t => {
                                        trackParameterApi.deleteTrackParameter(t)
                                    })
                                }
                                
                                // 修改事件参数
                                this.trackParameterList.filter(t => t.id).forEach(t => {
                                    trackParameterApi.updateTrackParameter(t)
                                })
                                
                                
                                let toArray = this.trackParameterList.filter(t => !t.id).map(t => t)
                                if (toArray.length > 0) {
                                    trackParameterApi.insertTrackParameter({ trackParameterList: toArray });
                                }
                            }
                        })
                    } else {
                        // 全部都是新增
                        let data = {}
                        data.trackEvent = this.insertTrackEvent
                        data.trackParameterList = this.trackParameterList
                        trackEventApi.insertTrackEventInfoAndParameter(data).then(result => {
                            if (result.code === 200) {
                                message.success(result.message)
                                this.getList()
                                this.open = false
                            }
                        })
                    }
                    return true
                } else {
                    return false
                }
            });
        },
        
        handleUpdateTrackEvent(data) {
            let obj = this
            this.$modal.confirm('确定修改' + data.data.eventName + ' 事件信息').then(function() {
                return trackEventApi.updateTrackEvent(data.data)
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success('修改成功')
                }
            }).catch(e => {
                obj.getList()
            })
        },
        handleUpdateTrackEventCommonStatus(data) {
            let obj = this
            this.$modal.confirm('确定要改变' + data.data.eventName + ' 事件的类型').then(function() {
                return trackEventApi.updateTrackEvent(data.data)
            }).then((result) => {
                if (result.code === 200) {
                    obj.getList();
                    message.success('修改成功')
                }
            }).catch(e => {
                obj.getList()
            })
        },
        handleViewDetail(data) {
            let projectAppId = data.data.projectAppId
            let eventId = data.data.id
            this.$router.push(`/trackAnalyse/eventAnalyse/${projectAppId}/${eventId}`)
        },
        goStep(step) {
            if (step === 1) {
                // 进入下一步
                // 进入下一步
                this.$refs.insertTrackEvent.validate((valid) => {
                    if (valid) {
                        this.currentSetEventInfoStatus = false
                        return true
                    } else {
                        return false
                    }
                });
            } else {
                this.currentSetEventInfoStatus = true
            }
        },
        addEmptyDynamicForm() {
            this.openTrackParameter = true
            this.updateTrackParameterStatus = false
            this.insertTrackParameter = {}
        },
        queryTrackParameter() {
            this.trackParameterList = []
            trackParameterApi.queryTrackParameter({
                pageSize: 1000,
                eventId: this.insertTrackEvent.id
            }).then(result => {
                if (result.code === 200) {
                    this.trackParameterList = result.data.result
                }
            })
        },
        submitTrackParameter() {
            this.$refs.insertTrackParameter.validate((valid) => {
                if (valid) {
                    this.openTrackParameter = false
                    if (!this.updateTrackParameterStatus) {
                        if (this.updateStatus) {
                            this.insertTrackParameter.eventId = this.insertTrackEvent.id
                        }
                        this.trackParameterList.push(this.insertTrackParameter)
                    }
                    return true
                } else {
                    return false;
                }
            });
        },
        handleUpdateTrackParameter(data) {
            this.openTrackParameter = true
            this.updateTrackParameterStatus = true
            this.insertTrackParameter = data
        },
        handleDeleterTrackParameter(index, data) {
            // 数据库中不存在
            this.trackParameterList.splice(index, 1)
            this.neededDeleteTrackParameterList.push(data)
        },
        queryTrackEvent(data) {
            trackEventApi.queryTrackEvent({ projectAppId: data, pageSize: 100000 }).then(result => {
                if (result.code === 200) {
                    if (!result.data || result.data.result.length === 0) {
                        message.success('此项目未查询到任何的埋点事件')
                        return
                    }
                    this.copyTrackParameter.queriedTrackEventList = result.data.result
                }
            })
        },
        handleCopyTrackParameter() {
            if (!this.copyTrackParameter.eventId) {
                message.error('请选择事件')
                return
            }
            
            // 查询埋点参数
            trackParameterApi.queryTrackParameter({
                eventId: this.copyTrackParameter.eventId,
                pageSize: 1000
            }).then(result => {
                if (result.code === 200) {
                    if (!result.data || result.data.result.length === 0) {
                        message.error('该埋点事件并没有任何的参数')
                        return
                    }
                    result.data.result.forEach((t, index) => {
                        t.id = undefined
                        if (this.updateStatus) {
                            t.eventId = this.insertTrackEvent.id
                        } else {
                            t.eventId = undefined
                        }
                        if (index === result.data.result.length - 1) {
                            this.trackParameterList = result.data.result
                            this.openCopyTrackParameter = false
                        }
                    })
                }
            })
        },
        handleImport() {
            if (!this.batchImportEventDeclaration.params.projectAppId) {
                message.error('请选择导入项目');
                return;
            }
            if (!this.batchImportEventDeclaration.params.file) {
                message.error('请选择文件!');
                return;
            }
            
            trackEventApi.batchImportTrackEvent(this.batchImportEventDeclaration.params).then(result => {
                if (result.code === 200) {
                    message.success('导入成功');
                    this.handleImportCancel();
                    this.getList();
                }
            });
        },
        handleImportCancel() {
            this.batchImportEventDeclaration.open = false;
            this.batchImportEventDeclaration.params.file = undefined;
        },
        handleFileChange(file) {
            this.batchImportEventDeclaration.params.file = file.raw;
        }
    }
};
</script>
